const PageXmlCteTags = () => import('./PageXmlCteTags');

export default {
  name: 'xml-cte-tags',
  path: 'xml-cte-tags',
  component: PageXmlCteTags,
  meta: {
    title: 'De x Para',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/routes.js